import { Avatar, Typography } from "@material-ui/core";
import React from "react";
import Badge, { BadgeTypes } from "../../../../components/common/PL/Badge/Badge";
import { getInitials } from "../../../../components/common/PL/Table/utils/getInitials";
import { ReservationIncomeType } from "../../types/reservation.types";
import useStyles from "./ReservationIncomeItemStyles";

interface ReservationIncomeItemProps {
  name: string;
  time: string;
  type: ReservationIncomeType;
  description: string;
  /** Lo que se llevó. Reemplaza al nombre del tipo en la etiqueta cuando viene. */
  option?: string;
  initials?: string;
}

const incomeTypeBadge: Record<ReservationIncomeType, { label: string; variant: BadgeTypes }> = {
  checkin: { label: "Menú", variant: "green" },
  alternative: { label: "Alternativa", variant: "yellow" },
  reject: { label: "Rechazado", variant: "red" },
};

export const ReservationIncomeItem = ({
  name,
  time,
  type,
  description,
  option,
  initials,
}: ReservationIncomeItemProps) => {
  const classes = useStyles();
  const badge = incomeTypeBadge[type];
  // El color sigue marcando el tipo; el texto dice qué se llevó, si se sabe.
  const badgeLabel = option || badge?.label;

  return (
    <div className={classes.root}>
      <Typography className={classes.time}>{time}</Typography>
      <Avatar className={classes.avatar}>{initials || getInitials(name, "")}</Avatar>
      <div className={classes.info}>
        <Typography className={classes.name}>{name}</Typography>
        <Typography className={classes.description}>{description}</Typography>
      </div>
      {badge && (
        <div className={classes.badge}>
          <Badge label={badgeLabel} variant={badge.variant} />
        </div>
      )}
    </div>
  );
};
